document.addEventListener("DOMContentLoaded", () => {
  const devOverlay = document.querySelector(".dev-overlay");
  if (devOverlay) {
    // Hide by default; show while Shift is held down OR Caps Lock is on.
    devOverlay.classList.add("dev-overlay--hidden");

    let shiftHeld = false;
    let capsOn = false;

    // Re-evaluate visibility based on the current Shift / Caps Lock state.
    const update = () => {
      if (shiftHeld || capsOn) {
        devOverlay.classList.remove("dev-overlay--hidden");
      } else {
        devOverlay.classList.add("dev-overlay--hidden");
      }
    };

    // `getModifierState("CapsLock")` reflects the OS Caps Lock state at the
    // time of the event, so we sync it on every key event we observe.
    document.addEventListener("keydown", (e) => {
      if (e.key === "Shift") shiftHeld = true;
      capsOn = e.getModifierState("CapsLock");
      update();
    });
    document.addEventListener("keyup", (e) => {
      if (e.key === "Shift") shiftHeld = false;
      capsOn = e.getModifierState("CapsLock");
      update();
    });

    // Reset Shift when the window loses focus so the overlay does not get
    // stuck visible if Shift is released outside the window. Caps Lock state
    // will be refreshed on the next key event.
    window.addEventListener("blur", () => {
      shiftHeld = false;
      update();
    });
  }
});
